module.exports = __webpack_public_path__ + "static/media/iconAlertConfirm.e87ba53e.svg";